import { ChatMessage } from './ChatMessage'
import { ChatAttachment } from './ChatAttachment'
import { ChatService } from './ChatService'

export class PersistentSendQueue {
  public sendQueue: ChatMessage[] = []

  private chatService: ChatService

  constructor (chatService: ChatService) {
    /* const sendQueue = localStorage.getItem('sendQueue')
    if (sendQueue) {
      this.sendQueue = JSON.parse(sendQueue)
    } */
    this.chatService = chatService
    this.upload()
  }

  private saveSendQueue () {
    // localStorage.setItem('sendQueue', JSON.stringify(this.sendQueue))
    // DISABLED cause it causes issues with large files
  }

  async upload () {
    this.sendQueue.forEach((message) => {
      this.chatService.sendMessage(message)
    })
  }

  addToQueue (chatMessage: ChatMessage): void {
    this.sendQueue.push(chatMessage)
    this.saveSendQueue()
    this.upload()
  }

  removeFromQueue (message: ChatMessage): void {
    this.sendQueue = this.sendQueue.filter(sendQueueMessage => message.uuid !== sendQueueMessage.uuid)
    this.saveSendQueue()
  }

  findAttachmentByUUID (uuid: string): ChatAttachment|null {
    let attachment = null
    this.sendQueue.forEach(chatMessage => {
      attachment = chatMessage.attachments.find(attachment => attachment.uuid === uuid)
    })
    return attachment
  }

  findMessageByAttachmentUUID (uuid: string): ChatMessage|null {
    const message = this.sendQueue.find(chatMessage => {
      return chatMessage.attachments.find(attachment => attachment.uuid === uuid)
    })
    if (!message) {
      return null
    }
    return message
  }
}
